/**
 * @copyright Copyright 2024-2024 Epic Systems Corporation
 * @file Insight metrics display for apps
 * @module Epic.AppOrchard.Showroom.AppInsightMetricsSection
 */

import { GridItem, SimpleGrid, Text } from "@chakra-ui/react";
import { IShowroomAppDownloadModel } from "ao/types/showroom";
import { FunctionComponent, memo } from "react";

interface IProps {
	listing: IShowroomAppDownloadModel;
	textColor: string;
}

export const AppInsightMetricsSection: FunctionComponent<IProps> = memo((props) => {
	const { listing, textColor } = props;

	return (
		<>
			{(listing.intendedPurposes.length > 0 || listing.intendedPurposes.length > 0) && (
				<SimpleGrid columns={{ sm: 1, lg: 2 }} spacing="10px">
					{listing.intendedPurposes.length > 0 && (
						<GridItem>
							<Text color={textColor} display="contents">
								Intended Purposes:{" "}
							</Text>
							{listing.intendedPurposes.map((x) => x.name).join(", ")}
						</GridItem>
					)}
					{listing.intendedUsers.length > 0 && (
						<GridItem>
							<Text color={textColor} display="contents">
								Intended Users:{" "}
							</Text>
							{listing.intendedUsers.map((x) => x.name).join(", ")}
						</GridItem>
					)}
				</SimpleGrid>
			)}
		</>
	);
});
